import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { clickCreateViewButton } from '../../custom-views/constants/events';
import { useIsFallbackModeEnabled } from 'find-and-filter-data/views-data/public';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const CreateCustomViewLink = ({
  onCreateCustomViewClick
}) => {
  const customViewsFallbackModeEnabled = useIsFallbackModeEnabled();
  const handleCreateCustomViewClick = () => {
    if (customViewsFallbackModeEnabled === true) return;
    onCreateCustomViewClick();
    trackEvent(clickCreateViewButton());
  };
  return /*#__PURE__*/_jsx(UIButton, {
    disabled: customViewsFallbackModeEnabled,
    onClick: handleCreateCustomViewClick,
    "data-test-id": "create-custom-view-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.viewsSidebar.actions.createCustomView"
    })
  });
};
CreateCustomViewLink.displayName = 'CreateCustomViewLink';
export default CreateCustomViewLink;